<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Add Pick</h3>
        <form>
          <table>
            <tr>
              <td>
                Pick Type:
              </td>
              <td>
                <select v-model="pickType" name="freedropdown">
                  <option>Free</option>
                  <option>Premium</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>
                Sport:
              </td>
              <td>
                <select v-model="sport" @change="onChange($event)">
                  <option v-for="s in sports" :key="s.id" :value="s">
                    {{ s.sport }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Category:</td>
              <td>
                <select v-model="category" @change="onCategoryChange()">
                  <option v-for="c in categories" :key="c.key" :value="c">
                    {{ c.label }}
                  </option>
                </select>
              </td>
            </tr>
            <tr v-if="category && category.mode !== 'prop'">
              <td>Game:</td>
              <td>
                <searchable-select
                  :key="category.key"
                  :filter-fn="filterFn"
                  :row-label-fn="rowLabelFn"
                  :row-key="rowKeyFn"
                  :initial-label="initialLabel"
                  placeholder="Search team…"
                  @select="onRowSelect"
                />
              </td>
            </tr>
            <tr v-if="category && category.mode === 'prop'">
              <td>Game:</td>
              <td>
                <searchable-select
                  key="prop-game"
                  :filter-fn="filterPropGamesFn"
                  :row-label-fn="propGameLabelFn"
                  :row-key="rowKeyFn"
                  :initial-label="initialGameLabel"
                  placeholder="Search team…"
                  @select="onPropGameSelect"
                />
              </td>
            </tr>
            <tr v-if="category && category.mode === 'prop' && selectedPropGame">
              <td>Prop:</td>
              <td>
                <searchable-select
                  :key="'prop-' + selectedPropGame.EventID"
                  :filter-fn="filterPropsFn"
                  :row-label-fn="propLabelFn"
                  :row-key="rowKeyFn"
                  :initial-label="initialLabel"
                  placeholder="Search player or prop…"
                  @select="onRowSelect"
                />
              </td>
            </tr>
            <tr>
              <td>
                Pick Type:
              </td>
              <td>
                <select v-model="betType" @change="fillLine()">
                  <option v-for="bt in betTypes" :key="bt.key" :value="bt">
                    {{ bt.value }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>
                Side:
              </td>
              <td>
                <select v-model="selection" @change="fillLine()">
                  <option v-for="bt in sideOptions" :key="bt.key" :value="bt">
                    {{ bt.value }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>
                Content:
              </td>
              <td>
                <textarea
                  v-model="content"
                  name="content"
                  cols="50"
                  rows="20"
                  maxlength="5000"
                ></textarea>
              </td>
            </tr>
            <tr>
              <td>
                Pick:
              </td>
              <td>
                <input
                  v-model="pick"
                  type="text"
                  name="pick"
                  size="33"
                  disabled="true"
                  maxlength="100"
                />
              </td>
            </tr>
            <tr>
              <td>
                Spread/OU:
              </td>
              <td>
                <input
                  v-model="side"
                  type="text"
                  name="side"
                  size="5"
                  maxlength="10"
                />
              </td>
            </tr>
            <tr>
              <td>
                Line:
              </td>
              <td>
                <input
                  v-model="price"
                  type="text"
                  name="price"
                  size="5"
                  maxlength="10"
                />
              </td>
            </tr>
            <tr>
              <td>
                Units:
              </td>
              <td>
                <input
                  v-model="units"
                  type="text"
                  name="units"
                  size="3"
                  maxlength="10"
                />
              </td>
            </tr>
          </table>
          <p>
            <input
              type="submit"
              name="submit"
              value="Submit Pick"
              @click.prevent="save"
            />
          </p>
        </form>
        <!-- main-colum END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import PickRepository from "../../data/pick.repository";
import PrerenderRepository from "../../data/prerender.repository";
import AdminRepository from "../../data/admin.repository";
import moment from "moment";
import SearchableSelect from "../../components/admin/SearchableSelect";
import {
  buildCategories,
  filterRows,
  rowLabel,
  buildPickString,
  propGames,
  propsForGame,
  propRowLabel,
  filterPropsInGame,
  isYesNoProp,
} from "../../data/oddsCategories";
export default {
  components: { SearchableSelect },
  data() {
    return {
      sports: this.$store.state.sports,
      betTypes: [
        {
          key: 0,
          value: "spread",
        },
        {
          key: 1,
          value: "moneyline",
        },
        {
          key: 2,
          value: "total",
        },
      ],
      betSelection: [
        {
          key: 0,
          value: "home",
        },
        {
          key: 1,
          value: "away",
        },
        {
          key: 2,
          value: "over",
        },
        {
          key: 3,
          value: "under",
        },
        {
          key: 4,
          value: "draw",
        },
        {
          key: 5,
          value: "none",
        },
      ],
      games: [],
      payload: { games: [], oddsTypes: [], props: [] },
      categories: [],
      category: null,
      selectedRow: null,
      selectedPropGame: null,
      initialLabel: "",
      initialGameLabel: "",
      id: "",
      pickType: "Free",
      betType: { key: 1, value: "moneyline" },
      selection: { key: 0, value: "home" },
      sport: "MLB",
      spread: "",
      // title: "",
      // date: moment().format("YYYY-MM-DD"),
      content: "",
      // pick: "",
      side: "",
      price: "",
      units: 1,
    };
  },
  computed: {
    sideOptions() {
      if (this.category && this.category.mode === "prop") {
        if (isYesNoProp(this.selectedRow)) {
          // Yes/No prop: Yes=home(0), No=away(1); prices live in the moneylines.
          return [
            { key: 0, value: "yes" },
            { key: 1, value: "no" },
          ];
        }
        return this.betSelection.filter(
          (s) => s.value === "over" || s.value === "under"
        );
      }
      return this.betSelection;
    },
    pick() {
      if (!this.selectedRow || !this.selection || !this.category) return "";
      return buildPickString(this.category.key, this.selectedRow, this.selection.value);
    },
  },
  created() {
    if (this.$route.params.id) {
      var that = this;
      PickRepository.getPick(this.$route.params.id).then((pick) => {
        this.id = pick.id;
        this.sport = pick.sport;
        this.price = pick.price;
        this.units = pick.units;
        this.side = pick.side;
        this.content = pick.content;
        this.pickType = pick.premium ? "Premium" : "Free";
        this.pick = pick.pick;
        that.onChange().then(() => {
          const jid = pick.record ? pick.record.json_odds_id : null;
          const propType = pick.record ? pick.record.prop_type : null;
          const oddsType =
            pick.record && pick.record.odds_type ? pick.record.odds_type : "Game";

          if (propType) {
            that.category =
              that.categories.find((c) => c.key === "Props") || that.categories[0];
          } else {
            that.category =
              that.categories.find((c) => c.key === oddsType) || that.categories[0];
          }

          if (that.category) {
            that.selectedRow = that.category.rows.find((r) => r.ID === jid) || null;
          }
          if (that.selectedRow) {
            if (that.category.mode === "prop") {
              that.selectedPropGame =
                propGames(that.payload).find(
                  (g) => g.EventID === that.selectedRow.EventID
                ) || null;
              if (that.selectedPropGame) {
                that.initialGameLabel = rowLabel(
                  { mode: "game" },
                  that.selectedPropGame
                );
              }
              that.initialLabel = propRowLabel(that.selectedRow);
            } else {
              that.initialLabel = rowLabel(that.category, that.selectedRow);
            }
            that.title = `${that.selectedRow.AwayTeam} vs. ${that.selectedRow.HomeTeam}`;
            that.betType = that.betTypes.find(
              (b) => b.key === Number(pick.record.bet_type)
            );
            if (
              that.category.mode === "prop" &&
              isYesNoProp(that.selectedRow)
            ) {
              // Yes/No prop stores bet_selection 0=Yes, 1=No.
              that.selection =
                Number(pick.record.bet_selection) === 1
                  ? { key: 1, value: "no" }
                  : { key: 0, value: "yes" };
            } else {
              that.selection = that.betSelection.find(
                (s) => s.key === Number(pick.record.bet_selection)
              );
            }
          }
        });
      });
    }
  },
  methods: {
    save() {
      const row = this.selectedRow;
      const isProp = this.category && this.category.mode === "prop";
      const p = {
        id: this.id,
        title: `${row.AwayTeam} vs. ${row.HomeTeam}`,
        content: this.content,
        sports_id: this.sport.id,
        price: this.price,
        units: this.units,
        side: this.side,
        date: row.MatchTime,
        premium: this.pickType === "Premium",
        pick: this.pick,
        bet_selection: this.selection.key,
        bet_type: this.betType.key,
        odds_id: row.ID,
        odds_type: isProp ? "Game" : this.category.key,
        prop_type: isProp ? row.PropType : null,
        participant: isProp && row.Participant ? row.Participant.Name : null,
      };
      PickRepository.save(p)
        .then(() => {
          this.$store.dispatch("getFreePicks");
          this.$root.$refs.toastr.s("Pick saved");
          this.$router.push("/admin");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
    fillLine() {
      if (!this.selectedRow) return;
      const o = (this.selectedRow.Odds && this.selectedRow.Odds[0]) || {};

      if (this.category && this.category.mode === "prop") {
        if (isYesNoProp(this.selectedRow)) {
          // Yes = MoneyLineHome, No = MoneyLineAway; no over/under number.
          this.side = "";
          this.price =
            this.selection.value === "no" ? o.MoneyLineAway : o.MoneyLineHome;
          return;
        }
        this.side = o.TotalNumber != null ? o.TotalNumber : "";
        this.price = this.selection.value === "under" ? o.UnderLine : o.OverLine;
        return;
      }

      const sel = this.selection.value;
      const bt = this.betType.value;
      if (sel === "home" && bt === "moneyline") {
        this.price = o.MoneyLineHome;
        this.side = "";
      }
      if (sel === "away" && bt === "moneyline") {
        this.price = o.MoneyLineAway;
        this.side = "";
      }
      if (sel === "away" && bt === "spread") {
        this.price = o.PointSpreadAwayLine;
        this.side = o.PointSpreadAway;
      }
      if (sel === "home" && bt === "spread") {
        this.price = o.PointSpreadHomeLine;
        this.side = o.PointSpreadHome;
      }
      if (sel === "over" && bt === "total") {
        this.price = o.OverLine;
        this.side = o.TotalNumber;
      }
      if (sel === "under" && bt === "total") {
        this.price = o.UnderLine;
        this.side = o.TotalNumber;
      }
    },
    onCategoryChange() {
      this.selectedRow = null;
      this.selectedPropGame = null;
      this.initialLabel = "";
      this.initialGameLabel = "";
      this.side = "";
      this.price = "";
      if (this.category && this.category.mode === "prop") {
        this.betType = { key: 2, value: "total" };
        this.selection = { key: 2, value: "over" };
      } else {
        this.betType = { key: 1, value: "moneyline" };
        this.selection = { key: 0, value: "home" };
      }
    },
    onRowSelect(row) {
      this.selectedRow = row;
      if (this.category && this.category.mode === "prop") {
        if (isYesNoProp(row)) {
          this.betType = { key: 1, value: "moneyline" };
          this.selection = { key: 0, value: "yes" };
        } else {
          this.betType = { key: 2, value: "total" };
          this.selection = { key: 2, value: "over" };
        }
      }
      this.fillLine();
    },
    filterFn(query) {
      return filterRows(this.category, query);
    },
    rowLabelFn(row) {
      return rowLabel(this.category, row);
    },
    rowKeyFn(row) {
      return row.ID;
    },
    // --- Prop two-step: pick a game, then a prop within that game ---
    filterPropGamesFn(query) {
      return filterRows(
        { mode: "game", rows: propGames(this.payload) },
        query
      );
    },
    propGameLabelFn(row) {
      return rowLabel({ mode: "game" }, row);
    },
    onPropGameSelect(game) {
      this.selectedPropGame = game;
      this.selectedRow = null;
      this.initialLabel = "";
      this.side = "";
      this.price = "";
    },
    filterPropsFn(query) {
      const rows = this.selectedPropGame
        ? propsForGame(this.payload, this.selectedPropGame.EventID)
        : [];
      return filterPropsInGame(rows, query);
    },
    propLabelFn(row) {
      return propRowLabel(row);
    },
    onChange() {
      return AdminRepository.getGames(this.sport.sport.toLowerCase()).then((d) => {
        const norm = (rows) =>
          (rows || []).forEach((g) => {
            g.MatchTime = moment.utc(g.MatchTime).local().format("YYYY-MM-DD");
          });
        norm(d.games);
        (d.oddsTypes || []).forEach((ot) => norm(ot.games));
        norm(d.props);

        this.payload = d;
        this.categories = buildCategories(d);
        this.category = this.categories[0] || null;
        this.selectedRow = null;
        this.selectedPropGame = null;
        this.initialLabel = "";
        this.initialGameLabel = "";
        this.betType = { key: 1, value: "moneyline" };
        this.selection = { key: 0, value: "home" };
        this.side = "";
        this.price = "";
        return d;
      });
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Pick.vue?5c042522